import React from "react";
import { Input, Row, Col, Select, Tooltip } from "antd";
import { SettingOutlined, SearchOutlined, PrinterOutlined } from "@ant-design/icons";

import "./SearchWidget.css";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import ExportExcelWidget from "components/ExportExcelWidget/ExportExcelWidget";
import { useEffect } from "react";
import { useState } from "react";
const { Search } = Input;
const { Option } = Select;

function SearchWidget(props) {
  const {
    dataList,
    groupList,
    isGroup,
    searchKey,
    setSearchKey,
    onSearch,
    sport_type,
    onColumnSettings,
    onReportChange,
    currentReport,
    onPrint,
    registrationType,
    facilityOptions,
    facilityFilter,
    onFacilityFilter,
  } = props;

  const isFacility = (registrationType || "").toLowerCase() === "facility";

  const [excelData, setExcelData] = useState([]);

  useEffect(() => {
    // When in group view, export the group summary list
    if (isGroup && groupList.length > 0) {
      const tmpList = groupList.map((x) => ({
        Label: x.label_name,
        "Count": x.reg_count,
        "Total": x.total_reg,
      }));
      setExcelData(tmpList);
      return;
    }

    if (dataList.length > 0) {
      let tmpList = [];

      // Handle Registration Totals report
      if (currentReport === "registration_totals") {
        dataList.map((x) => {
          let tmpObj = {
            Type: x.type === "registration" ? "Registration" : "Program",
            Name: x.name,
            Count: x.count || 0,
            "Total Amount": x.total_amount || 0,
            "Last Timestamp": x.last_timestamp || "N/A",
          };
          tmpList = [...tmpList, tmpObj];
        });
      }
      // Handle Registrations (transactions) report
      else if (currentReport === "registrations" && !isFacility) {
        dataList.map((x) => {
          let tmpObj = {
            "Parent First Name": x.parent_first,
            "Parent Last Name": x.parent_last,
            "Parent Email": x.p_email,
            "Phone": x.p_cell_phone,
            "Total Checkout": x.total_checkout,
            "Payment Method": x.payment_method,
            "Discount Code": x.discount_code,
            "Discount Amount": x.discount_amount,
            "Registration Date": x.reg_date,
            "Participant Count": x.participant_count,
            "Program Count": x.program_count,
          };
          tmpList = [...tmpList, tmpObj];
        });
      }
      // Handle Facility Registrations (paid) + Unpaid for facility
      else if (isFacility && (currentReport === "registrations" || currentReport === "unpaid")) {
        dataList.map((x) => {
          let tmpObj = {
            "ID": x.id,
            "Applicant Name": x.applicant_name,
            "Facility": x.facility,
            "Event Date": x.event_date,
            "Start Time": x.event_start_time,
            "End Time": x.event_end_time,
            "Total Hours": x.total_hours,
            "Amount": x.total_amount,
            "Email": x.contact_email,
            "Phone": x.contact_phone,
            "Status": x.status,
            "Submitted": x.created_at,
          };
          tmpList = [...tmpList, tmpObj];
        });
      }
      // Handle Participants report
      else if (currentReport === "participants") {
        if (sport_type != undefined && sport_type == "camp") {
          dataList.map((x) => {
            let tmpObj = {
              "First Name": x.camper_first_name,
              "Last Name": x.camper_last_name,
              "Registration Name": x.registration_name,
              "Team Name": x.team_name == null ? "" : x.team_name,
              Age: x.camper_age,
              Grade: x.camper_grade == 0 ? "K" : x.camper_grade,
              Street: x.camper_street,
              City: x.camper_city,
              State: x.camper_state,
              "Zip/Postal Code": x.camper_zip,
              "Camper T-Shirt Size": x.camper_t_shirt,
              "List of known allergies, health or behavioral concerns": window.atob(window.btoa(x.camper_health)),
              "Parent First Name": x.p_first_name,
              "Parent Last Name": x.p_last_name,
              "Parent Email": x.p_email,
              "Parent Mobile Telephone Number": x.p_cell_phone,
              "Parent Home Telephone Number": x.p_home_phone,
              "Parent Mobile Carrier": x.p_relation,
              "Additional Contact First Name": x.a_first_name,
              "Additional Contact Last Name": x.a_last_name,
              "Additional Mobile Telephone Number": x.a_cell_phone,
              "Additional Home Telephone Number": x.a_home_phone,
              "Additional Email Address": x.a_email,
              "Additional Relation to Camper": x.a_relation,
              "Contact First Name": x.c_first_name,
              "Contact Last Name": x.c_last_name,
              "Contact Email": x.c_email,
              "Contact Phone Number": x.c_cell_phone,
              "Registration Date": x.reg_date,
              "Total Checkout": x.total_checkout,
              Fee: x.processing_fee,
              "Payment Method": x.payment_method,
            };
            tmpList = [...tmpList, tmpObj];
          });
        } else {
          dataList.map((x) => {
            let tmpObj = {
              "First Name": x.first_name,
              "Last Name": x.last_name,
              "Registration Group": x.fee_label,
              "Team Name": x.team_name,
              "Participant Gender": x.gender,
              "Participant Dob": x.birthday,
              "Participant Email": x.email,
              "Participant Telephone": x.tele_phone,
              "Participant Grade": x.grade == "0" ? "K" : x.grade,
              "Participant Height (in inches)": x.height,
              "Previous basketball experience": x.experience,
              "Parent/Guardian First Name": x.p_first_name,
              "Parent/Guardian Last Name": x.p_last_name,
              "Parent/Guardian Home Phone": x.p_home_phone,
              "Parent/Guardian Cell Phone": x.p_cell_phone,
              "Parent/Guardian Email": x.p_email,
              "Parent/Guardian Relation": x.p_relation,
              Address: x.address,
              City: x.city,
              "State/Province": x.state,
              "Zip/Postal Code": x.zip,
              "Adult interested in Coaching?": x.coaching,
              "Contact First Name": x.c_first_name,
              "Contact Last Name": x.c_last_name,
              "Contact Email": x.c_email,
              "Contact Phone Number": x.c_cell_phone,
              "Registration Date": x.reg_date,
              Fee: x.fee,
              "Processing Fee": x.processing_fee,
              "Total Fee": x.total_fee,
              Status: x.payment_status,
              "Discount Code": x.discount_code,
            };
            tmpList = [...tmpList, tmpObj];
          });
        }
      }
      // Handle Group-by drill-down (discount_code, reg_date, payment_method, group_program)
      // After clicking a group row, isGroup=false but currentReport stays as the group type.
      // dataList = userList = participant records — export using same format as participants.
      else if (["discount_code", "reg_date", "payment_method", "group_program"].includes(currentReport)) {
        if (sport_type != undefined && sport_type == "camp") {
          dataList.map((x) => {
            let tmpObj = {
              "First Name": x.camper_first_name,
              "Last Name": x.camper_last_name,
              "Registration Name": x.registration_name,
              "Team Name": x.team_name == null ? "" : x.team_name,
              Age: x.camper_age,
              Grade: x.camper_grade == 0 ? "K" : x.camper_grade,
              Street: x.camper_street,
              City: x.camper_city,
              State: x.camper_state,
              "Zip/Postal Code": x.camper_zip,
              "Camper T-Shirt Size": x.camper_t_shirt,
              "List of known allergies, health or behavioral concerns": window.atob(window.btoa(x.camper_health)),
              "Parent First Name": x.p_first_name,
              "Parent Last Name": x.p_last_name,
              "Parent Email": x.p_email,
              "Parent Mobile Telephone Number": x.p_cell_phone,
              "Parent Home Telephone Number": x.p_home_phone,
              "Parent Mobile Carrier": x.p_relation,
              "Additional Contact First Name": x.a_first_name,
              "Additional Contact Last Name": x.a_last_name,
              "Additional Mobile Telephone Number": x.a_cell_phone,
              "Additional Home Telephone Number": x.a_home_phone,
              "Additional Email Address": x.a_email,
              "Additional Relation to Camper": x.a_relation,
              "Contact First Name": x.c_first_name,
              "Contact Last Name": x.c_last_name,
              "Contact Email": x.c_email,
              "Contact Phone Number": x.c_cell_phone,
              "Registration Date": x.reg_date,
              "Total Checkout": x.total_checkout,
              Fee: x.processing_fee,
              "Payment Method": x.payment_method,
            };
            tmpList = [...tmpList, tmpObj];
          });
        } else {
          dataList.map((x) => {
            let tmpObj = {
              "First Name": x.first_name,
              "Last Name": x.last_name,
              "Registration Group": x.fee_label,
              "Team Name": x.team_name,
              "Participant Gender": x.gender,
              "Participant Dob": x.birthday,
              "Participant Email": x.email,
              "Participant Telephone": x.tele_phone,
              "Participant Grade": x.grade == "0" ? "K" : x.grade,
              "Participant Height (in inches)": x.height,
              "Previous basketball experience": x.experience,
              "Parent/Guardian First Name": x.p_first_name,
              "Parent/Guardian Last Name": x.p_last_name,
              "Parent/Guardian Home Phone": x.p_home_phone,
              "Parent/Guardian Cell Phone": x.p_cell_phone,
              "Parent/Guardian Email": x.p_email,
              "Parent/Guardian Relation": x.p_relation,
              Address: x.address,
              City: x.city,
              "State/Province": x.state,
              "Zip/Postal Code": x.zip,
              "Adult interested in Coaching?": x.coaching,
              "Contact First Name": x.c_first_name,
              "Contact Last Name": x.c_last_name,
              "Contact Email": x.c_email,
              "Contact Phone Number": x.c_cell_phone,
              "Registration Date": x.reg_date,
              Fee: x.fee,
              "Processing Fee": x.processing_fee,
              "Total Fee": x.total_fee,
              Status: x.payment_status,
              "Discount Code": x.discount_code,
            };
            tmpList = [...tmpList, tmpObj];
          });
        }
      }
      // Handle Facility Applications report
      else if (currentReport === "facility_applications") {
        dataList.map((x) => {
          let tmpObj = {
            "ID": x.id,
            "Applicant Name": x.applicant_name,
            "Facility": x.facility,
            "Event Date": x.event_date,
            "Start Time": x.event_start_time,
            "End Time": x.event_end_time,
            "Total Hours": x.total_hours,
            "Amount": x.total_amount,
            "Email": x.contact_email,
            "Phone": x.contact_phone,
            "Status": x.status,
            "Submitted": x.created_at,
          };
          tmpList = [...tmpList, tmpObj];
        });
      }
      setExcelData(tmpList);
    } else {
      setExcelData([]);
    }
  }, [dataList, groupList, isGroup, currentReport, sport_type, isFacility]);

  return (
    <div>
      {/* Report Type, Search, and Action Buttons - all in one row */}
      <Row className="follower-cnt-txt" align="middle" justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <Row gutter={16} align="middle">
            <Col>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <label style={{ color: 'rgba(0, 0, 0, 0.85)', fontWeight: 400, fontSize: 14, whiteSpace: 'nowrap' }}>
                  Report Type:
                </label>
                <Select
                  className="common-select report-type-select"
                  placeholder="Select Report"
                  style={{ width: 360 }}
                  value={currentReport || (isFacility ? "facility_applications" : "participants")}
                  onChange={(v) => {
                    onReportChange(v);
                  }}
                >
                  {isFacility ? (
                    <>
                      <Option value="facility_applications">Facility Applications</Option>
                      <Option value="facility_calendar">Facility Calendar</Option>
                      <Option value="registrations">Transactions</Option>
                      <Option value="unpaid">Unpaid</Option>
                    </>
                  ) : (
                    <>
                      <Option value="participants">Participants</Option>
                      <Option value="registrations">Registrations</Option>
                      <Option value="registration_totals">Registration Totals</Option>
                      <Option value="discount_code">Group by Discount Code</Option>
                      <Option value="reg_date">Group by Registration Date</Option>
                      <Option value="payment_method">Group by Payment Method</Option>
                      <Option value="group_program">Group by Program</Option>
                      <Option value="unpaid">Unpaid Registrations</Option>
                    </>
                  )}
                </Select>
              </div>
            </Col>
            {isFacility && (
              <Col>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ color: 'rgba(0, 0, 0, 0.85)', fontWeight: 400, fontSize: 14, whiteSpace: 'nowrap' }}>
                    Facility:
                  </label>
                  <Select
                    className="common-select report-type-select"
                    style={{ width: 240 }}
                    value={facilityFilter || "all"}
                    onChange={(v) => onFacilityFilter && onFacilityFilter(v)}
                  >
                    <Option value="all">All Facilities</Option>
                    {(facilityOptions || []).map((facility) => (
                      <Option key={facility} value={facility}>
                        {facility}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
            )}
            <Col>
              <span style={{ marginLeft: 16 }}>Count: {isGroup ? groupList.length : dataList.length}</span>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row gutter={16} align="middle">
            <Col>
              <Search
                placeholder={isGroup ? "Search label" : "Search name or email"}
                allowClear
                onSearch={(v) => {
                  onSearch(v);
                }}
                onChange={(e) => {
                  setSearchKey(e.target.value);
                }}
                value={searchKey}
                enterButton={<SearchOutlined />}
              />
            </Col>
            <Col>
              <ExportExcelWidget
                excelData={excelData}
                fileName={"registration_users"}
                onlyColumnsWithValues={true}
              />
            </Col>
            {currentReport === "registration_totals" ? (
              <Col>
                <Tooltip title="Print this report">
                  <CommonButton onClick={onPrint}>
                    <PrinterOutlined style={{ marginRight: 6 }} />
                    Print
                  </CommonButton>
                </Tooltip>
              </Col>
            ) : onColumnSettings ? (
              <Col>
                <Tooltip title="Customize table columns">
                  <CommonButton
                    onClick={onColumnSettings}
                  >
                    <SettingOutlined style={{ marginRight: 6 }} />
                    Columns
                  </CommonButton>
                </Tooltip>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default SearchWidget;
